import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import { isNull } from 'lodash-es'
import { createDynamicScriptTag } from '@/js/components/HubSpot/Helpers/hubspot-helper.js'

export const loadExternalServices = ({ /* i18n, */ store, withTimeout = true, consent }) => {
  const { /* advertising, functional, */ necessary /* , performance */ } = consent
    ? consent
    : window?.CookieFirst?.consent || {}

  if (!necessary) {
    // console.log('Not loading external services (no necessary consent)')
    // window.addEventListener('cf_consent', function (event) {
    //   console.log(event)
    //   loadExternalServices({ i18n, store, withTimeout: false, consent: event.detail })
    // })
    // return
  }

  setTimeout(
    () => {
      loadZenloop(store)
    },
    withTimeout ? 3000 : 1000,
  )
  setTimeout(
    () => {
      loadHubspot(store)
    },
    withTimeout ? 3000 : 1000,
  )
}

export const loadZenloop = store => {
  const isCheckoutConfirm = document.querySelector('.aimeos.checkout-confirm')
  const isReturnTicketForm = document.getElementById('bu_return_tickets')
  const currentUrl = new URL(window.location.href)
  const preventZl = currentUrl.searchParams.get('zl') === '0'

  if (preventZl) {
    // console.log('Not loading Zenloop NPS (queryparam)')
    return
  }

  if (isCheckoutConfirm) {
    // console.log('Not loading Zenloop NPS on checkout-confirm page')
    return
  }

  if (isReturnTicketForm) {
    // console.log('Not loading Zenloop NPS on return ticket page')
    return
  }

  const customerNumber = store.getters[`${STORE_MODULES.APP}/${APP_GETTER.CUSTOMER_NUMBER}`]
  const username = store.getters[`${STORE_MODULES.APP}/${APP_GETTER.USERNAME}`]
  const zenloopSurveys = store.getters[`${STORE_MODULES.APP}/${APP_GETTER.ZENLOOP_SURVEYS}`]

  if (!zenloopSurveys?.nps) {
    // console.log('Not loading Zenloop NPS (no nps survey configured)')
    return
  }

  if (!customerNumber) {
    // console.log('Not loading Zenloop NPS (not logged in)')
    return
  }

  const alreadyOnPage = document.getElementById('zl-website-overlay-loader')
  if (alreadyOnPage) {
    // console.log('Not loading Zenloop NPS (already on page)')
    return
  }

  console.log(`Adding Zenloop NPS on page for ${customerNumber}`)

  window.Zenloop = window.Zenloop || {}
  window.Zenloop.recipient = {
    identity: customerNumber,
    identity_type: 'custom',
    properties: {
      customerNumber,
      username,
    },
  }

  createZenloopScriptTag({ survey: zenloopSurveys.nps })
}

export const createZenloopScriptTag = async ({
  id = 'zl-website-overlay-loader',
  survey,
  element,
  reloadWhenExisting = false,
} = {}) => {
  const alreadyOnPage = document.getElementById(id)

  if (reloadWhenExisting && alreadyOnPage) {
    const currentUrl = new URL(window.location.href)

    if (!isNull(currentUrl.searchParams.get('zl'))) {
      console.log('not trying to reload without zl')
      return
    }

    console.log('Not loading Zenloop NPS (already on page). Trigger page reload with zl=0')

    currentUrl.searchParams.append('zl', 0)
    window.location.replace(currentUrl.toString())
    return
  }

  if (alreadyOnPage) {
    console.log('Not loading Zenloop NPS (already on page)')
    return
  }
  await import(/* webpackChunkName: "zlcss" */ '@/styles/external/zenloop.scss')

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.id = id
  script.src = `https://zenloop-website-overlay-production.s3.amazonaws.com/loader/zenloop.load.min.js?survey=${survey}`
  if (element) {
    element.appendChild(script)
    return
  }
  document.body.appendChild(script)
}

export const loadHubspot = store => {
  let defaultBrand = store.getters[`${STORE_MODULES.APP}/${APP_GETTER.USER_BRANDS}`][0]
  let brand = store.getters[`${STORE_MODULES.APP}/${APP_GETTER.SELECTED_BRAND}`]

  if (!defaultBrand) {
    return
  }

  if (!brand) {
    brand = defaultBrand.long
  }

  createDynamicScriptTag(brand)
}
